import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "sonner";
import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { Stats } from "./components/site/Stats";
import { Services } from "./components/site/Services";
import { Sorglos } from "./components/site/Sorglos";
import { Process } from "./components/site/Process";
import { CTABand } from "./components/site/CTABand";
import { References } from "./components/site/References";
import { Testimonial } from "./components/site/Testimonial";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";
import { CookieBanner } from "./components/site/CookieBanner";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";

const Home = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [hash]);

  return (
    <main>
      <Hero />
      <Stats />
      <Services />
      <CTABand testId="cta-band-1" />
      <Sorglos />
      <Process />
      <References />
      <Testimonial />
      <CTABand testId="cta-band-2" />
      <Contact />
    </main>
  );
};

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
        <Footer />
        <CookieBanner />
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
